/* eslint-disable no-console */

import CONFIG from 'Config/settings';
import { readAuthTokenCookie } from 'Utils/auth/authUtils';
import * as loginUtils from 'Services/auth/loginUtils';
import { isUTCDateInPast } from 'Utils/date/dateUtils';
import JwtDecode from 'jwt-decode';
import { ProfileService } from 'Services/ServiceFactory';
import { LoginResponse } from './models';

export default class IRWAuthenticationApiClient {
  constructor() {
    const { COUNTRY, LANGUAGE, API } = CONFIG;
    this.apiSourceSystem = 'irw';
    this.apiUrl = `${API.IRW.HOST}/retail/iows/${COUNTRY}/${LANGUAGE}/customer`;
    this.headers = {
      Accept: 'application/vnd.ikea.api+json;version=2',
      Consumer: 'OWPRLO',
      Contract: '42427'
    };
  }

  // eslint-disable-next-line class-methods-use-this
  isAuthenticated() {
    return new Promise(resolve => {
      const response = new LoginResponse();
      response.authenticated = false;
      const authToken = readAuthTokenCookie();
      const decodedToken = authToken && JwtDecode(authToken);
      if (authToken && !isUTCDateInPast(decodedToken.exp)) {
        const partyUid = decodedToken['https://accounts.ikea.com/partyUId'];
        ProfileService.getProfileGraphql(partyUid)
          .then(user => {
            if (user) {
              resolve(ProfileService.extractUserInfo(user, decodedToken));
            } else {
              resolve(response);
            }
          })
          .catch(err => {
            console.log(`Get user info failed with ${err}`);
            // TODO::: resolve the line below when the logging is properly introduced in the application
            // logger.error('Get user info failed with ' + err);
            resolve(response);
          });
      } else {
        resolve(response);
      }
    });
  }

  /**
   * Set a new password
   *
   * @param {obj} data
   * data contains:
   * - userId
   * - currentPassword
   * - newPassword
   * - newPasswordRetype
   */
  setNewPassword(data) {
    const contract = {
      Consumer: 'OWPRLO',
      Contract: '42427'
    };
    return new Promise((resolve, reject) => {
      // Ugly hack for India until the MAMMUT consumer has rights for this
      // endpoint. Using the credentials for the family application. This
      // is only safe to do here since India is the only current user of
      // this API client.
      const authTokenCookie = readAuthTokenCookie();
      const { COUNTRY, LANGUAGE, API } = CONFIG;
      const cmsServiceUrl = `${API.CMS.HOST}/api/profile/iows/${COUNTRY}/${LANGUAGE}/password`;
      const irwServiceUrl = `${this.apiUrl}/password?authErrors=true`;
      const headers = {
        Accept: this.headers.Accept,
        ...(!CONFIG.FEATURE.ENABLE_IRW_CMS && contract),
        ...(CONFIG.FEATURE.ENABLE_IRW_CMS && {
          'x-client-id': `${CONFIG.API.CMS.CLIENT_ID}`
        }),
        ...(authTokenCookie && {
          Authorization: `Bearer ${authTokenCookie}`
        })
      };

      const userId = data.userLogin ? data.userLogin : data.userId;

      const bodyObj = {
        userId,
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
        newPasswordRetype: data.newPasswordRetype
      };

      fetch(CONFIG.FEATURE.ENABLE_IRW_CMS ? cmsServiceUrl : irwServiceUrl, {
        method: 'PUT',
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyObj)
      })
        .then(response => {
          if (response.status === 200) {
            resolve({ response: {}, request: data });
          }

          // Handle HTTP response errors
          return response.json();
        })
        .then(json => {
          if (json?.authFailReasonList?.length) {
            const { reasonCode } = json.authFailReasonList[0];
            const error = loginUtils.reasonCodeToErrorObj(reasonCode);
            console.log('irw error1 ', error, ' reasonCode ', reasonCode);
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ response: { errors: [error] } });
          }
          if (json?.authReason) {
            const { reasonCode } = json.authReason;
            const error = loginUtils.reasonCodeToErrorObj(reasonCode);
            console.log('irw error2 ', error, ' reasonCode ', reasonCode);
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ response: { errors: [error] } });
          }
          return undefined;
        });
    });
  }
}
